<template>
  <div>
    <h4 class="text-center">{{ $t('Personalizations') }}</h4>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t('Size') }}</th>
                <th>{{ $t('Number') }}</th>
                <th>{{ $t('Home') }}/{{ $t('Away') }}</th>
                <th>{{ $t('Field') }}/{{ $t('Goalie') }}</th>
              </tr>
            </thead>
            <tbody
              v-for="(qty, qtyKey) in quantities"
              :key="qtyKey"
              class="form-group"
            >
              <tr
                v-for="(personalization, pIndex) in qty.personalizations"
                :key="pIndex"
              >
                <td>
                  {{ $t('Size') }}
                  {{ String(qtyKey).substring(catalogProductIdLength) }}
                  #{{ pIndex + 1 }}
                </td>
                <td>
                  <input
                    required
                    type="text"
                    maxlength="2"
                    style="display: inline"
                    :id="`numberpersonalizations[${qtyKey}-${pIndex}]`"
                    :name="`numberpersonalizations[${qtyKey}-${pIndex}]`"
                    class="form-control"
                  />
                </td>
                <td>
                  <select
                    class="custom-select custom-select-sm"
                    :name="`location[${qtyKey}-${pIndex}]`"
                  >
                    <option value="home">{{ $t('Home') }}</option>
                    <option value="away">{{ $t('Away') }}</option>
                  </select>
                </td>
                <td>
                  <select
                    class="custom-select custom-select-sm"
                    :name="`position[${qtyKey}-${pIndex}]`"
                  >
                    <option value="field">{{ $t('Field') }}</option>
                    <option value="goalie">{{ $t('Goalie') }}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Quantity {
  personalizations: unknown[];
  showDropdown: boolean;
  qty: number;
}

defineProps<{
  quantities: Record<string, Quantity>;
  catalogProductIdLength: number;
}>();
</script>


